const MESSAGE_TIME_DURATION = 2;

export {
  MESSAGE_TIME_DURATION
};
